import { render, staticRenderFns } from "./Userorderywc.vue?vue&type=template&id=14c57fca&scoped=true&"
import script from "./Userorderywc.vue?vue&type=script&lang=js&"
export * from "./Userorderywc.vue?vue&type=script&lang=js&"
import style0 from "./Userorderywc.vue?vue&type=style&index=0&id=14c57fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c57fca",
  null
  
)

export default component.exports